// Shared by world.ts and levels.ts
import type { Goal, ObjData, Placement } from '../../core/types';

export const K = 'space';
export const DEG = Math.PI / 180;

// ---------- level data with this world's own fields ----------
/** Goal with a homing beam: the rocket hatch (bell) pulls the bunny in the last bit (beam = range) */
export interface SpaceGoal extends Goal { beam?: number }
/** Rocket placement: v = launch speed (default 11) */
export interface RocketPl extends Placement { v?: number }
/** Fixed planet in the level: r = radius, R = pull ring, G = pull strength, amax = max pull, col = gradient */
export interface PlanetObj extends ObjData { r?: number; R?: number; G?: number; amax?: number; col?: [string, string] }
/** Hatch that slides away when a button fires its id */
export interface HatchObj extends ObjData { w?: number; h?: number; id: string }
